import React from 'react'
import { Redirect } from 'react-router-dom'
import Cookies from "universal-cookie";
const cookies = new Cookies();

function ProtectedRoutes({ component: Component, ...restOfProps }) {
    let token = cookies.get("wmtoken");
    const { children } = restOfProps
    if (!token) {
        return <Redirect to="/" replace />;
    }else {
        return children;
    }
}

export default ProtectedRoutes
